export default __webpack_public_path__ + "images/e81b570e8cb9024c241e344120c3eeff.svg";